class BackToTop {
    constructor(buttonSelector, textSelector) {
        this.button = document.querySelector(buttonSelector);
        this.textElement = document.querySelector(textSelector);
        this.toggleHeight = window.outerHeight * 2;
        
        this.init();
    }
    
    init() {
        window.addEventListener("scroll", () => this.onScroll());
        this.button.addEventListener("click", (event) => this.scrollToTop(event));
    }
    
    onScroll() {
        if (window.scrollY > this.toggleHeight) {
            this.button.classList.add("active");
        } else {
            this.button.classList.remove("active");
        }
    }
    
    scrollToTop(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
    
    updateText(text) {
        if (this.textElement) {
            this.textElement.textContent = text;
        }
    }
}